import { qoursesApiInstructor } from '@/api/qourses-instructor.tsx'
import { useQuery } from '@tanstack/react-query'
import { CalendarEntity } from '../../../qourses-api-client'

export default function useGetInstructorCalendars(): {
  calendars: CalendarEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
  refetch: () => void
} {
  const {
    data: calendars,
    isLoading,
    isError,
    refetch,
  } = useQuery(['instructor', 'calendars'], async () => {
    const calendars = await qoursesApiInstructor.calendar.calendarControllerGetCalendarsV1('true')

    return calendars.filter((calendar: { archived: never }) => !calendar.archived)
  })

  let isEmpty = true

  if (calendars === undefined) {
    return { calendars: [], isLoading, isEmpty, isError, refetch }
  }

  if (calendars.length > 0) {
    isEmpty = false
  }

  return { calendars, isLoading, isEmpty, isError, refetch }
}
